import { styled } from "@mui/material/styles";
import TableCell from "@mui/material/TableCell";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  "&.MuiTableCell-head": {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    fontWeight: "bold",
  },
  "&.MuiTableCell-body": {
    padding: "8px",
    textAlign: "center",
    margin: "auto",
  },
}));

export default StyledTableCell;
